import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter } from 'react-router'
import { injectIntl, defineMessages } from 'react-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { fields } from '../../common/lib/redux-fields'
import formValidation from '../../common/lib/formValidation'
import { validateCreateOpenQuestion } from '../../common/lessons/validations'
import { updateMe } from '../../common/users/actions'
import { exerciseTypes, languages, roles } from '../../common/config'
import { LessonFormHeader } from '.'
import { Popup, withNameInput, Button, TextInput, SelectInput } from '../components'


class OpenQuestionForm extends React.Component {
  state = {
    openQuestions: [{ question: '', answer: [''], id: 0, maxPoints: 1 }],
    languages: {
      baseLang: (this.props.viewer && this.props.viewer.userLanguage) || 'en',
      foreignLang: (this.props.viewer && this.props.viewer.foreignLanguage) || 'es',
    },
    languagesList: Object.keys(languages).map(key =>
      ({ key, label: languages[key].name })),
    isPublic: true,
    lastUpdatedId: null,
    showForeignSuggestion: false,
    showTranslationSuggestion: false,
  }

  componentDidMount() {
    const { lesson } = this.props

    if (!lesson) {
      let openQuestions = []
      
      for (let i = 0; i < 3; i += 1) {
        openQuestions.push(
          { question: '', answer: [''], id: i, maxPoints: 1 },
        )
      }
      this.setState({ openQuestions })
    } else {
      const openQuestions = lesson.openQuestions.map(item => ({
        question: item.question,
        answer: item.answer,
        maxPoints: item.maxPoints || 1,
      }))
      this.setState({
        id: lesson.id,
        openQuestions,
        isPublic: lesson.isPublic,
      })
    }
  }

  componentWillUnmount() {
    const { fields } = this.props
    fields.$reset()
  }

  async submitForm(e) {
    e.preventDefault()
    const { fields, submit, history, isTestForm, hideForm } = this.props
    const { languages, id, isPublic } = this.state

    const openQuestions = this.state.openQuestions.filter(item => item.question)

    const values = {
      ...fields.$values(),
      id,
      baseLang: languages.baseLang,
      foreignLang: languages.foreignLang,
      openQuestions,
      isPublic,
      type: exerciseTypes.OPEN_QUESTION,
    }
    if (await submit(values) !== false) {
      fields.$reset()
      if (isTestForm) {
        hideForm()
      } else {
        history.push('/app/lessons')
      }
    }
  }

  handleQuestionChange(newValue, idx) {
    const { openQuestions } = this.state

    const newOpenQuestions = openQuestions.map((item, sidx) => {
      if (idx !== sidx) return item
      
      return { ...item, question: newValue }
    })

    this.setState({ openQuestions: newOpenQuestions })
  }

  handlePointsChange = idx => e => {

    const newOpenQuestions = this.state.openQuestions.map((openQuestion, sidx) => {
      if (idx !== sidx) return openQuestion
      return { ...openQuestion, maxPoints: e.target.value }
    })

    this.setState({ openQuestions: newOpenQuestions })
  }

  handleAddQuestion = (e) => {
    e.preventDefault()
    const newOpenQuestions = this.state.openQuestions.concat([
      { question: '', answer: [''], maxPoints: 1 }])

    this.setState({
      openQuestions: newOpenQuestions,
    })
  }

  handleRemoveQuestion(e, idx) {
    const { openQuestions } = this.state
    e.preventDefault()
    this.setState({
      openQuestions: openQuestions.filter((_, sidx) => idx !== sidx),
    })
  }

  handleChangeLang(e, base) {
    const { languages } = this.state

    if (base === 'base') {
      this.setState({
        languages: {
          ...languages,
          baseLang: e.target.value,
        },
      })
    } else {
      this.setState({
        languages: {
          ...languages,
          foreignLang: e.target.value,
        },
      })
    }
  }

  render() {
    const { viewer, lesson, updateMe, fields, isDetailPage, errorMessage, intl } = this.props
    const { openQuestions } = this.state

    return (
      <div className="float-left width-full">
        {/*
          !isDetailPage && (viewer && !viewer.seenGuides.translationDescription) &&
          <Popup
            title={intl.formatMessage(messages.popupTitle)}
            text={intl.formatMessage(messages.popupContent)}
            onClick={() => updateMe({ seenGuides: { translationDescription: true } })}
          />
        */}
        <form className="flex-column" onSubmit={(e) => this.submitForm(e)}>
          <LessonFormHeader
            isDetailPage={isDetailPage}
            errors={errorMessage}
            fields={fields}
            lesson={lesson}
            //instructions={intl.formatMessage(messages.defaultInstructions)}
          />
          
          {
            openQuestions.map((item, idx) => (
              <div className="item-box" key={idx}>
                <span className="order-num">
                  {idx + 1}
                </span>
                <TextInput
                  type="text"
                  name={`question-${idx}`}
                  value={item.question}
                  className="width-80p"
                  onChange={e => this.handleQuestionChange(e.target.value, idx)}
                  label={intl.formatMessage(messages.questionLabel)}
                  disabled={isDetailPage}
                />

                {
                  viewer && viewer.role === roles.TEACHER &&
                  <TextInput
                    className="points-input width-10p"
                    type="text"
                    name={`points${idx}`}
                    value={item.maxPoints}
                    onChange={this.handlePointsChange(idx)}
                    label={intl.formatMessage(messages.points)}
                    disabled={isDetailPage}
                  />
                }
                {
                  !isDetailPage ?
                    <span className="delete-icon" onClick={(e) => this.handleRemoveQuestion(e, idx)}>
                      <FontAwesomeIcon icon="trash" />
                    </span>
                  :
                    <span>&nbsp;</span>
                }
              </div>
            ))
          }
          {
            !isDetailPage &&
            <React.Fragment>
              <div className="item-box">
                <div className="block-center">
                  <Button onClick={this.handleAddQuestion}>
                    {intl.formatMessage(messages.addQuestion)}
                  </Button>
                </div>
              </div>
              <div className="float-left block-center bottom-save-button">
                <Button big positive type="submit">
                  {intl.formatMessage(messages.save)}
                </Button>
              </div>
            </React.Fragment>
          }
        </form>
      </div>
    )
  }
}

OpenQuestionForm.defaultProps = {
  isDetailPage: false,
  viewer: null,
  lesson: null,
}

OpenQuestionForm.propTypes = {
  intl: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  viewer: PropTypes.object,
  lesson: PropTypes.object,
  isDetailPage: PropTypes.bool,
  updateMe: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  errorMessage: PropTypes.any.isRequired,
}

OpenQuestionForm = withRouter(OpenQuestionForm)

const enhance = compose(
  // withNameInput,
  formValidation(props => ({
    validationFunc: validateCreateOpenQuestion,
    submitFunc: props.submitLesson,
  })),
  connect(state => ({
    viewer: state.users.viewer,
  }), { updateMe }),
  fields({
    path: 'OpenQuestionForm',
    fields: [
      'name', 'instructions', 'prologueText', 'youtubeVideo', 'subject', 'tags',
    ],
    getInitialState: ({ lesson, viewer, ...props }) => ({
      name: (lesson && lesson.name) || props.name || '',
      instructions: ((lesson && lesson.instructions)
        ? lesson.instructions : ''),
      prologueText: (lesson && lesson.prologueText) || props.prologueText || '',
      youtubeVideo: (lesson && lesson.youtubeVideo) || props.youtubeVideo || '',
      tags: (lesson && lesson.tags) || props.tags || [],
      subject: (lesson && lesson.subject) || props.subject || ((viewer && viewer.subjects.length && !lesson)
        ? viewer.subjects[0] : ''),
    }),
  }),
  injectIntl,
)

export default enhance(OpenQuestionForm)

const messages = defineMessages({
  questionLabel: {
    id: 'openQuestion.form.questionLabel',
    defaultMessage: 'Otázka',
  },
  addQuestion: {
    id: 'openQuestion.form.addQuestion',
    defaultMessage: 'Pridať otázku',
  },
  points: {
    id: 'openQuestion.form.points',
    defaultMessage: 'Body',
  },
  save: {
    id: 'openQuestion.form.save',
    defaultMessage: 'Uložiť',
  },
})



// WEBPACK FOOTER //
// ./src/browser/forms/OpenQuestionForm.js